import React from "react";

export default function TermsAndConditions() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Terms & Conditions</h1>
      <p>Welcome to KWICTH. By using our services, you agree to the following terms.</p>

      <h2>Use of Website</h2>
      <p>
        You agree to use the website legally and responsibly. You must not
        misuse our services or violate any laws.
      </p>

      <h2>Orders & Payments</h2>
      <p>
        All orders are subject to availability and confirmation. Payments must
        be made through approved payment gateways like Razorpay.
      </p>

      <h2>Pricing</h2>
      <p>
        Prices may change at any time without prior notice. Final prices will
        be shown at checkout.
      </p>

      <h2>Contact Us</h2>
      <p>
        For any issues regarding terms, contact:<br />
        📞 8770561028 <br />
        📧 support@kwicth.in
      </p>
    </div>
  );
}
